module.exports = __webpack_public_path__ + "static/media/brooke.ce8d61f4.png";